if (!customElements.get('quick-order-list-increase-button')) {
customElements.define(
    'quick-order-list-increase-button',
    class QuickOrderListIncreaseButton extends HTMLButtonElement {
      constructor() {
        super();

        const quantityInput = this.parentElement.querySelector('.quantity__input');

        if(quantityInput) {
          this.addEventListener('click', () => {
            const value = parseInt(quantityInput.value, 10) || 0;
            const carton = parseInt((this.dataset.carton || '').replace(/\D/g, ''), 10) || 20;

            if (this.dataset.inventory !== undefined) {
              const inventory = parseInt(this.dataset.inventory, 10);
              if (value >= inventory) return;
              quantityInput.value = Math.min(value + carton, inventory);
            } else {
              quantityInput.value = value + carton;
            }

            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      }

    }, { extends: 'button' }
  );
}